import client from "./client";

type Id = string | number;

export const dashboardsApi = {
  list: (scope?: "mine" | "all") =>
    client.get("/admin/scheduled-dashboards", scope ? { params: { scope } } : undefined),
  create: (data: Record<string, unknown>) => client.post("/admin/scheduled-dashboards", data),
  update: (id: Id, data: Record<string, unknown>) => client.put(`/admin/scheduled-dashboards/${id}`, data),
  remove: (id: Id) => client.delete(`/admin/scheduled-dashboards/${id}`),

  listTiles: (id: Id) => client.get(`/admin/scheduled-dashboards/${id}/tiles`),
  addTile: (id: Id, data: Record<string, unknown>) => client.post(`/admin/scheduled-dashboards/${id}/tiles`, data),
  updateTile: (id: Id, tid: Id, d: Record<string, unknown>) => client.put(`/admin/scheduled-dashboards/${id}/tiles/${tid}`, d),
  deleteTile: (id: Id, tid: Id) => client.delete(`/admin/scheduled-dashboards/${id}/tiles/${tid}`),

  triggerRun: (id: Id) => client.post(`/admin/scheduled-dashboards/${id}/run`),
  adminSnapshots: (id: Id) => client.get(`/admin/scheduled-dashboards/${id}/snapshots`),

  getShares: (id: Id) => client.get(`/admin/scheduled-dashboards/${id}/shares`),
  setShares: (id: Id, uids: string[]) => client.put(`/admin/scheduled-dashboards/${id}/shares`, { user_ids: uids }),

  previewSql: (sql: string, key?: string | null, config?: import("axios").AxiosRequestConfig) =>
    client.post("/admin/scheduled-dashboards/preview-sql", { metric_sql: sql, datasource_key: key || null }, config),

  myList: () => client.get("/dashboards"),
  get: (id: Id) => client.get(`/dashboards/${id}`),
  snapshots: (id: Id) => client.get(`/dashboards/${id}/snapshots`),
  latestSnapshot: (id: Id) => client.get(`/dashboards/${id}/snapshots/latest`),
  snapshot: (id: Id, sid: Id) => client.get(`/dashboards/${id}/snapshots/${sid}`),
};
